module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11768/assets/images/tiktok_banner.png"